import styled from "styled-components";
import {wheelAmbientModeLightColor} from "../../wheel-color-helper";

export const AmbientModeLightLineDefaultBox = styled.div<{lineIndex: number}>`
    position: absolute;
    left: 50%;
    top: 50%;
    width: 1.6%;
    height: 88%;
    border-radius: 50%;
    
    background: ${wheelAmbientModeLightColor};
    transform: translate(-50%, -50%);
    transform: translate(-50%, -50%) rotate(calc(22.5deg * ${({lineIndex}) => lineIndex}));
    filter: blur(4px);
    box-shadow: ${wheelAmbientModeLightColor} 0 0 20px 6px;
    
    &:nth-of-type(2n) {
      width: 9%;
      height: 82%;
      filter: blur(8px);
    }
`;
